module.exports = __webpack_public_path__ + "media/images/course/__depo_04-ec885bb0b895b2d784628e207a2e4a04.png";